import React from "react";
import {Space, Button} from "antd";
const ContentExam = props => {
  const {data, closeModal} = props;
  //   Bắt buộc khai báo hàm closeModal
  return (
    <div>
      {data}

      {/* Bắt buộc đặt thẻ Space có class modal-footer */}
      <Space className="modal-footer">
        <Button danger onClick={closeModal}>
          Hủy
        </Button>
        <Button type="primary" onClick={closeModal}>
          Xác nhận
        </Button>
      </Space>
    </div>
  );
};

export default ContentExam;
